import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/walkthrough/`

export default {
  getTemplateData(id) {
    return ApiService.get(`${resourceUrl}template/${id}`)
  },
  save(id, walkthroughData, imageData) {
    return ApiService.post(`${resourceUrl}template`, {
      walkthroughTemplateConfig: { id, ...walkthroughData },
      imageData,
    })
  },
}
